import { getNames } from 'country-list'
import languageNameMap from 'language-name-map/map'
import React, { useEffect, useState } from 'react'

//Custom components
import Checkbox from 'components/Checkbox'
import TagInput from 'components/Input/TagInput'
import TextArea from 'components/Input/TextArea'
import TextField from 'components/Input/TextField'
import AutoComplete from 'components/Select/AutoComplete'
import { Editor } from '@tinymce/tinymce-react'

//Custom hooks
import useTagList from 'hooks/useTagList'

//assets
import { DURATION_LIST } from 'app/utils/list'
import NumberInput from 'components/Input/NumberInput'
import Switch from 'components/Switch/Switch'
import CheckboxV2 from 'components/Checkbox/CheckboxV2'
import RichTextEditor from 'components/RichTextEditor/RichTextEditor'
import Tooltip from 'components/Tooltip'

const ListingForm = (props) => {
  const [skillsTags] = useTagList()
  const formik = props.formik

  useEffect(() => {
    formik.setTouched({}, false)
    formik.setSubmitting(false)
  }, [])

  console.log(formik)

  return (
    <div>
      <header className="pb-[25px] md:pb-10">
        <h3 className="text-black-100 leading-[24px] md:leading-6 text-[18px] md:text-lg font-medium">
          Create your first job post
        </h3>
      </header>
      <div className="space-y-[20px] md:space-y-7">
        <TextField
          label="Job Title"
          name="title"
          id="title"
          onChange={(e) => {
            e.preventDefault()
            formik.setFieldValue('title', e.target.value)
          }}
          value={formik.values.title}
          error={
            formik.touched['title'] && formik.errors['title']
              ? formik.errors['title']
              : ''
          }
        />
        <div className="grid md:grid-cols-2 gap-x-4 space-y-[20px] md:space-y-0">
          <TagInput
            label="Language Needed"
            list={_.map(languageNameMap, (v, k) => {
              return {
                id: v.name,
                name: v.name,
              }
            })}
            placeholder="Select Languages"
            name="languages"
            id="languages"
            onChange={(value) => {
              formik.setFieldValue('language', value)
            }}
            value={formik.values['language']}
          />
          <AutoComplete
            value={formik.values['duration']}
            name="duration"
            optionClassName="text-[13px] ml-3"
            id="duration"
            onChange={(value) => {
              formik.setFieldValue('duration', value)
            }}
            error={
              formik.touched['duration'] && formik.errors['duration']
                ? formik.errors['duration']
                : ''
            }
            label="Job Duration"
            data={DURATION_LIST}
          />
        </div>
        <div className="space-y-5">
          <p className="text-gray-300 leading-[16px] text-[12px] md:text-xs font-medium">
            Choose pay preference(s): hourly, annual salary or both.
          </p>
          <div>
            <div className="flex items-center justify-between">
              <CheckboxV2
                value={formik.values.payPreference.includes('hourly')}
                onChange={(e) => {
                  let prev = formik.values.payPreference
                  let prevMode = formik.values.payPreferenceMode
                  if (prev.includes('hourly')) {
                    formik.setFieldValue(
                      'payPreference',
                      prev.filter((v) => v !== 'hourly')
                    )
                    formik.setFieldValue(
                      'payPreferenceMode',
                      prevMode.filter((v) => v !== 'hourlyRange')
                    )
                  } else {
                    formik.setFieldValue('payPreference', [
                      ...prev.filter((v) => v !== 'negotiable'),
                      'hourly',
                    ])
                  }
                }}
                label={
                  <div className="text-black-100 font-semibold text-sm leading-5">
                    Hourly
                  </div>
                }
                sizeClass="w-6 h-6"
                rectClass="border-gray-500 focus-within:border-gray-500 w-6 h-6"
                checkClass="w-4 h-4 text-green-200"
                inputboxClassName="bg-white border-[2px] rounded border-gray-400 w-[24px] h-[24px] flex flex-shrink-0 justify-center items-center mr-2 border-solid"
              />
              <div className="flex items-center">
                <p
                  className="text-Light-Blue font-Inter font-medium text-sm leading-5"
                  style={{
                    color:
                      formik.values.payPreferenceMode.includes('hourlyRange') &&
                      formik.values.payPreference.includes('hourly')
                        ? 'var(--Light-Blue, #808191)'
                        : 'var(--Text, #52B4DA)',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: '16px',
                  }}
                >
                  Exact Pay
                </p>
                <div className="ml-4">
                  <Switch
                    isChecked={
                      formik.values.payPreferenceMode.includes('hourlyRange') &&
                      formik.values.payPreference.includes('hourly')
                    }
                    isDisabled={!formik.values.payPreference.includes('hourly')}
                    onChange={(e) => {
                      let prev = formik.values.payPreferenceMode
                      if (prev.includes('hourlyRange')) {
                        formik.setFieldValue(
                          'payPreferenceMode',
                          prev.filter((v) => v !== 'hourlyRange')
                        )
                      } else {
                        formik.setFieldValue('payPreferenceMode', [
                          ...prev,
                          'hourlyRange',
                        ])
                        formik.setFieldValue('exactHourlyRate', '')
                        formik.setFieldValue('minHourlyRate', '')
                        formik.setFieldValue('maxHourlyRate', '')
                      }
                    }}
                  />
                </div>
                <p
                  className="text-Text font-Inter font-medium text-sm leading-5 ml-4"
                  style={{
                    color:
                      formik.values.payPreferenceMode.includes('hourlyRange') &&
                      formik.values.payPreference.includes('hourly')
                        ? 'var(--Light-Blue, #52B4DA)'
                        : 'var(--Text, #808191)',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: '16px',
                  }}
                >
                  Range
                </p>
              </div>
            </div>
            {formik.values.payPreferenceMode.includes('hourlyRange') &&
            formik.values.payPreference.includes('hourly') ? (
              <div className="grid grid-cols-2 gap-x-5 mt-5">
                <div className="space-y-2.5">
                  <NumberInput
                    placeholder="From"
                    prefix="$"
                    suffix="USD"
                    name="minHourlyRate"
                    id="minHourlyRate"
                    onChange={formik.handleChange}
                    value={formik.values.minHourlyRate}
                    error={
                      formik.touched['minHourlyRate'] &&
                      formik.errors['minHourlyRate']
                        ? formik.errors['minHourlyRate']
                        : ''
                    }
                  />
                  <div className="text-gray-300 leading-4 text-[12px] md:text-xs font-medium">
                    Min Hourly Rate
                  </div>
                </div>
                <div className="space-y-2.5">
                  <NumberInput
                    prefix="$"
                    suffix="USD"
                    placeholder="To"
                    name="maxHourlyRate"
                    id="maxHourlyRate"
                    onChange={formik.handleChange}
                    value={formik.values.maxHourlyRate}
                    error={
                      formik.touched['maxHourlyRate'] &&
                      formik.errors['maxHourlyRate']
                        ? formik.errors['maxHourlyRate']
                        : ''
                    }
                  />
                  <div className="text-gray-300 leading-4 text-[12px] md:text-xs font-medium">
                    Max Hourly Rate
                  </div>
                </div>
              </div>
            ) : (
              <div className="grid grid-cols-1 gap-x-5 mt-5">
                <div className="space-y-2.5">
                  <NumberInput
                    prefix="$"
                    suffix="USD"
                    placeholder="Exact Pay"
                    name="exactHourlyRate"
                    id="exactHourlyRate"
                    onChange={formik.handleChange}
                    value={formik.values.exactHourlyRate}
                    error={
                      formik.touched['exactHourlyRate'] &&
                      formik.errors['exactHourlyRate']
                        ? formik.errors['exactHourlyRate']
                        : ''
                    }
                    disabled={!formik.values.payPreference.includes('hourly')}
                  />
                  <div className="text-gray-300 leading-4 text-[12px] md:text-xs font-medium">
                    Exact Hourly Rate
                  </div>
                </div>
              </div>
            )}
          </div>
          <div>
            <div className="flex items-center justify-between">
              <CheckboxV2
                value={formik.values.payPreference.includes('annual')}
                onChange={(e) => {
                  let prev = formik.values.payPreference
                  let prevMode = formik.values.payPreferenceMode
                  if (prev.includes('annual')) {
                    formik.setFieldValue(
                      'payPreference',
                      prev.filter((v) => v !== 'annual')
                    )
                    formik.setFieldValue(
                      'payPreferenceMode',
                      prevMode.filter((v) => v !== 'annualRange')
                    )
                  } else {
                    formik.setFieldValue('payPreference', [
                      ...prev.filter((v) => v !== 'negotiable'),
                      'annual',
                    ])
                  }
                }}
                label={
                  <div className="text-black-100 font-semibold text-sm leading-5">
                    Annual Salary
                  </div>
                }
                sizeClass="w-6 h-6"
                rectClass="border-gray-500 focus-within:border-gray-500 w-6 h-6"
                checkClass="w-4 h-4 text-green-200"
                inputboxClassName="bg-white border-[2px] rounded border-gray-400 w-[24px] h-[24px] flex flex-shrink-0 justify-center items-center mr-2 border-solid"
              />
              <div className="flex items-center">
                <p
                  className="text-Light-Blue font-Inter font-medium text-sm leading-5"
                  style={{
                    color:
                      formik.values.payPreferenceMode.includes('annualRange') &&
                      formik.values.payPreference.includes('annual')
                        ? 'var(--Light-Blue, #808191)'
                        : 'var(--Text, #52B4DA)',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: '16px',
                  }}
                >
                  Exact Pay
                </p>
                <div className="ml-4">
                  <Switch
                    isChecked={
                      formik.values.payPreferenceMode.includes('annualRange') &&
                      formik.values.payPreference.includes('annual')
                    }
                    isDisabled={!formik.values.payPreference.includes('annual')}
                    onChange={(e) => {
                      let prev = formik.values.payPreferenceMode
                      if (prev.includes('annualRange')) {
                        formik.setFieldValue(
                          'payPreferenceMode',
                          prev.filter((v) => v !== 'annualRange')
                        )
                      } else {
                        formik.setFieldValue('payPreferenceMode', [
                          ...prev,
                          'annualRange',
                        ])
                        formik.setFieldValue('exactAnnualSalary', '')
                        formik.setFieldValue('maxAnnualSalary', '')
                        formik.setFieldValue('minAnnualSalary', '')
                      }
                    }}
                  />
                </div>
                <p
                  className="text-Text font-Inter font-medium text-sm leading-5 ml-4"
                  style={{
                    color:
                      formik.values.payPreferenceMode.includes('annualRange') &&
                      formik.values.payPreference.includes('annual')
                        ? 'var(--Light-Blue, #52B4DA)'
                        : 'var(--Text, #808191)',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    lineHeight: '16px',
                  }}
                >
                  Range
                </p>
              </div>
            </div>
            {formik.values.payPreferenceMode.includes('annualRange') &&
            formik.values.payPreference.includes('annual') ? (
              <div className="grid grid-cols-2 gap-x-5 mt-5">
                <div className="space-y-2.5">
                  <NumberInput
                    prefix="$"
                    suffix="USD"
                    placeholder="From"
                    name="minAnnualSalary"
                    id="minAnnualSalary"
                    onChange={formik.handleChange}
                    value={formik.values.minAnnualSalary}
                    error={
                      formik.touched['minAnnualSalary'] &&
                      formik.errors['minAnnualSalary']
                        ? formik.errors['minAnnualSalary']
                        : ''
                    }
                  />
                  <div className="text-gray-300 leading-4 text-[12px] md:text-xs font-medium">
                    Min Annual Salary
                  </div>
                </div>
                <div className="space-y-2.5">
                  <NumberInput
                    prefix="$"
                    suffix="USD"
                    placeholder="To"
                    name="maxAnnualSalary"
                    id="maxAnnualSalary"
                    onChange={formik.handleChange}
                    value={formik.values.maxAnnualSalary}
                    error={
                      formik.touched['maxAnnualSalary'] &&
                      formik.errors['maxAnnualSalary']
                        ? formik.errors['maxAnnualSalary']
                        : ''
                    }
                  />
                  <div className="text-gray-300 leading-4 text-[12px] md:text-xs font-medium">
                    Max Annual Salary
                  </div>
                </div>
              </div>
            ) : (
              <div className="grid grid-cols-1 gap-x-5 mt-5">
                <div className="space-y-2.5">
                  <NumberInput
                    prefix="$"
                    suffix="USD"
                    placeholder="Exact Pay"
                    name="exactAnnualSalary"
                    id="exactAnnualSalary"
                    onChange={formik.handleChange}
                    value={formik.values.exactAnnualSalary}
                    error={
                      formik.touched['exactAnnualSalary'] &&
                      formik.errors['exactAnnualSalary']
                        ? formik.errors['exactAnnualSalary']
                        : ''
                    }
                    disabled={!formik.values.payPreference.includes('annual')}
                  />
                  <div className="text-gray-300 leading-4 text-[12px] md:text-xs font-medium">
                    Exact Annual Salary
                  </div>
                </div>
              </div>
            )}
            <div className="flex flex-col gap-4 sm:gap-4 sm:flex-row mt-4">
              <Checkbox
                value={
                  formik.values.payPreference.includes('hourly') &&
                  formik.values.payPreference.includes('annual')
                }
                onChange={(e) => {
                  let prev = formik.values.payPreference
                  if (prev.includes('hourly') && prev.includes('annual')) {
                    formik.setFieldValue(
                      'payPreference',
                      prev.filter((v) => v !== 'hourly' && v !== 'annual')
                    )
                  } else {
                    formik.setFieldValue('payPreference', [
                      ...prev.filter((v) => v !== 'negotiable'),
                      'hourly',
                      'annual',
                    ])
                  }
                }}
                label={
                  <div className="text-black-100 font-semibold text-sm leading-5">
                    Both Hourly & Salary
                  </div>
                }
                sizeClass="w-6 h-6"
                rectClass="border-gray-500 focus-within:border-gray-500 w-6 h-6"
                checkClass="w-4 h-4 text-green-200"
              />
              <Checkbox
                value={formik.values.payPreference.includes('negotiable')}
                onChange={(e) => {
                  let prev = formik.values.payPreference
                  if (prev.includes('negotiable')) {
                    formik.setFieldValue(
                      'payPreference',
                      prev.filter((v) => v !== 'negotiable')
                    )
                  } else {
                    formik.setFieldValue('payPreference', ['negotiable'])
                  }
                }}
                label={
                  <div className="text-black-100 font-semibold text-sm leading-5">
                    Negotiable
                  </div>
                }
                sizeClass="w-6 h-6"
                rectClass="border-gray-500 focus-within:border-gray-500 w-6 h-6"
              />
            </div>
          </div>
          {formik.errors['payPreference'] && formik.touched['payPreference'] ? (
            <div className="text-red-300 text-[12px] md:text-xs font-semibold">
              {formik.errors['payPreference']}
            </div>
          ) : (
            ''
          )}
        </div>
        <div>
          <TagInput
            label="Job Skill Tags"
            list={_.map(skillsTags, (v, k) => {
              return {
                id: v.id,
                name: v.name,
              }
            })}
            name="jobSkills"
            id="jobSkills"
            onChange={(value) => {
              formik.setFieldValue('jobSkills', value)
            }}
            value={formik.values.jobSkills}
            placeholder="Job Skills"
            limitText="*Required at least 3 tags"
          />
          {formik.errors['jobSkills'] && formik.touched['jobSkills'] ? (
            <div className="text-red-300 text-[12px] md:text-xs font-semibold mt-2.5">
              {formik.errors['jobSkills']}
            </div>
          ) : (
            ''
          )}
        </div>
        <div className="mb-4">
          <label className="text-gray-300 leading-[16px] text-[12px] md:text-xs font-medium">
            Job Description
          </label>
          <RichTextEditor
            name="jobDescription"
            value={formik.values.jobDescription}
            onChange={formik.handleChange}
            placeholder="Enter your Job Description"
          />
          {formik.errors['jobDescription'] &&
          formik.touched['jobDescription'] ? (
            <div className="text-red-300 text-[12px] md:text-xs font-semibold mt-3">
              {formik.errors['jobDescription']}
            </div>
          ) : (
            ''
          )}
        </div>
        <div className="mb-4">
          <div className="flex gap-2">
            <label className="text-gray-300 leading-[16px] md:leading-4 text-[12px] md:text-xs font-medium mb-[20px]">
              Cover Letter Video
            </label>
            <Tooltip text="Profiles with intro videos are shown at the top of search results for employers. Job seekers with intro videos are much more likely to receive job offers.">
              <div className="cursor-pointer">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7Z"
                    fill="#1E3E85"
                  />
                  <path
                    d="M4.58496 5.36295C4.58496 5.05703 4.68318 4.74707 4.87962 4.43307C5.07605 4.11907 5.36267 3.85902 5.73947 3.6529C6.1163 3.44691 6.55588 3.34386 7.0582 3.34375C7.52507 3.34375 7.93728 3.4299 8.29482 3.6022C8.65237 3.77451 8.92854 4.0088 9.12334 4.30507C9.31493 4.59074 9.41671 4.92719 9.41559 5.27116C9.41559 5.54489 9.35999 5.78481 9.24879 5.99093C9.14455 6.18787 9.01099 6.36784 8.85269 6.52468C8.69975 6.67446 8.42523 6.92647 8.02913 7.28068C7.93657 7.3635 7.84868 7.45139 7.76586 7.54394C7.70865 7.60709 7.65919 7.67686 7.61856 7.75175C7.58735 7.81188 7.56226 7.875 7.54369 7.94015C7.52594 8.00297 7.49936 8.11326 7.46396 8.27101C7.40274 8.60597 7.21115 8.77343 6.88916 8.77337C6.81134 8.77537 6.73389 8.76189 6.66132 8.7337C6.58876 8.7055 6.52252 8.66316 6.46646 8.60914C6.35211 8.49977 6.29495 8.33715 6.29498 8.12128C6.29498 7.85077 6.33684 7.61653 6.42055 7.41854C6.5004 7.22647 6.6132 7.04982 6.75387 6.89658C6.9315 6.70929 7.11851 6.53114 7.3142 6.3628C7.52028 6.1825 7.66924 6.04643 7.76108 5.95461C7.85224 5.86365 7.93027 5.76041 7.9929 5.64787C8.05554 5.53572 8.08799 5.40922 8.08707 5.28075C8.08896 5.15777 8.06427 5.03583 8.01466 4.92328C7.96506 4.81072 7.89173 4.71022 7.79968 4.62863C7.60802 4.45159 7.36086 4.36303 7.0582 4.36296C6.70394 4.36296 6.4431 4.45228 6.27568 4.63093C6.10826 4.80958 5.96655 5.07283 5.85054 5.4207C5.74104 5.78483 5.53333 5.96689 5.22743 5.96689C5.14225 5.96859 5.05765 5.9525 4.97905 5.91965C4.90044 5.88679 4.82956 5.8379 4.77093 5.77609C4.64695 5.64883 4.58496 5.51112 4.58496 5.36295ZM6.94229 10.6572C6.75303 10.6599 6.56959 10.5919 6.42785 10.4664C6.28125 10.3392 6.20798 10.1613 6.20803 9.93264C6.20598 9.83721 6.22382 9.74241 6.26041 9.65425C6.297 9.5661 6.35153 9.48653 6.42055 9.4206C6.48909 9.35268 6.57062 9.29928 6.66026 9.26357C6.74991 9.22787 6.84583 9.2106 6.94229 9.21279C7.0372 9.21141 7.13141 9.22909 7.21936 9.26478C7.3073 9.30048 7.3872 9.35345 7.4543 9.42057C7.52141 9.4877 7.57436 9.5676 7.61003 9.65556C7.6457 9.74351 7.66335 9.83773 7.66195 9.93264C7.66195 10.1581 7.58948 10.3352 7.44454 10.464C7.30766 10.5897 7.12815 10.6588 6.94229 10.6572Z"
                    fill="white"
                  />
                </svg>
              </div>
            </Tooltip>
          </div>
          <div className="flex flex-col gap-4 sm:gap-4 sm:flex-row mt-2">
            <Checkbox
              value={formik.values?.coverLetterVideoRequirement === 'mandatory'}
              onChange={(e) => {
                formik.setFieldValue('coverLetterVideoRequirement', 'mandatory')
              }}
              label={
                <div className="text-black-100 font-semibold text-sm leading-5">
                  Mandatory
                </div>
              }
              sizeClass="w-6 h-6"
              rectClass="border-gray-500 focus-within:border-gray-500 w-6 h-6"
            />
            <Checkbox
              value={
                formik.values?.coverLetterVideoRequirement === 'encouraged'
              }
              onChange={(e) => {
                formik.setFieldValue(
                  'coverLetterVideoRequirement',
                  'encouraged'
                )
              }}
              label={
                <div className="text-black-100 font-semibold text-sm leading-5">
                  Encouraged, not required
                </div>
              }
              sizeClass="w-6 h-6"
              rectClass="border-gray-500 focus-within:border-gray-500 w-6 h-6"
            />
            <Checkbox
              value={
                formik.values?.coverLetterVideoRequirement === 'not_required'
              }
              onChange={(e) => {
                formik.setFieldValue(
                  'coverLetterVideoRequirement',
                  'not_required'
                )
              }}
              label={
                <div className="text-black-100 font-semibold text-sm leading-5">
                  No Cover Letter Video
                </div>
              }
              sizeClass="w-6 h-6"
              rectClass="border-gray-500 focus-within:border-gray-500 w-6 h-6"
            />
          </div>
          {formik.errors['coverLetterVideoRequirement'] &&
          formik.touched['coverLetterVideoRequirement'] ? (
            <div className="text-red-300 text-[12px] md:text-xs font-semibold mt-3">
              {formik.errors['coverLetterVideoRequirement']}
            </div>
          ) : (
            ''
          )}
        </div>
        <div className="mb-4">
          <TextArea
            id="coverLetterVideoInstructions"
            name="coverLetterVideoInstructions"
            label="Cover Letter Video Instructions"
            value={formik.values.coverLetterVideoInstructions}
            onChange={formik.handleChange}
            placeholder="Enter video description..."
            error={
              formik.touched['coverLetterVideoInstructions'] &&
              formik.errors['coverLetterVideoInstructions']
                ? formik.errors['coverLetterVideoInstructions']
                : ''
            }
          />
        </div>
      </div>
    </div>
  )
}

export default ListingForm
